import { urlsListSectionReducersAndSagas } from '@dbh/urls-list-section';

var reducersAndSagas = [urlsListSectionReducersAndSagas];

export { reducersAndSagas as default };
